import { OverTimeUnsegmentedVizViews } from '../types';
import { overTimeUnsegmentedBarChartViewConfig } from './bar-char/view-config';
import { overTimeUnsegmentedLineChartViewConfig } from './line-chart/view-config';
import { overTimeUnsegmentedTableViewConfig } from './table-view/view-config';

export const overTimeViewConfigs = [
  {
    name: OverTimeUnsegmentedVizViews.LINE_CHART,
    viewConfig: overTimeUnsegmentedLineChartViewConfig,
  },
  {
    name: OverTimeUnsegmentedVizViews.TABLE_VIEW,
    viewConfig: overTimeUnsegmentedTableViewConfig,
  },
  {
    name: OverTimeUnsegmentedVizViews.BAR_CHART,
    viewConfig: overTimeUnsegmentedBarChartViewConfig,
  },
];
